// Generated by Melange

import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__Contractor from "../../models/Contractor.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Document from "../../grpc/Document.js";
import * as Buhta_cabinet__Dropdowns from "../../components/molecules/Dropdowns.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__PhoneField from "../../components/html/PhoneField.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const emptyContractor = {
  tin: "",
  "type'": /* ORG_TYPE_UNSPECIFIED */0,
  country_code: "",
  resident: true,
  name: "",
  refnum: "",
  email: "",
  phone: "",
  contact: "",
  legal_address: "",
  real_address: "",
  chief_tin: "",
  chief_position: "",
  chief_family_name: "",
  chief_given_name: "",
  chief_patronymic_name: "",
  chief_acting_on: "",
  kbe: "",
  bank_accounts: /* [] */0
};

function CreateContractorPage(Props) {
  let org = Props.org;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Новый контрагент",
        route: contextRoute({
              TAG: /* Manage */7,
              _0: /* Contractors */{
                _0: /* List */0
              }
            })
      });
  const match$2 = React.useState(function () {
        return emptyContractor;
      });
  const setContractor = match$2[1];
  const contractor = match$2[0];
  const match$3 = React.useState(function () {
        return Buhta_cabinet__Contractor.emptyBankAccount;
      });
  const setBankAccount = match$3[1];
  const bankAccount = match$3[0];
  React.useEffect((function () {
          if (Caml_obj.caml_equal(bankAccount, Buhta_cabinet__Contractor.emptyBankAccount)) {
            Curry._1(setContractor, (function (state) {
                    return {
                            tin: state.tin,
                            "type'": state["type'"],
                            country_code: state.country_code,
                            resident: state.resident,
                            name: state.name,
                            refnum: state.refnum,
                            email: state.email,
                            phone: state.phone,
                            contact: state.contact,
                            legal_address: state.legal_address,
                            real_address: state.real_address,
                            chief_tin: state.chief_tin,
                            chief_position: state.chief_position,
                            chief_family_name: state.chief_family_name,
                            chief_given_name: state.chief_given_name,
                            chief_patronymic_name: state.chief_patronymic_name,
                            chief_acting_on: state.chief_acting_on,
                            kbe: state.kbe,
                            bank_accounts: /* [] */0
                          };
                  }));
          } else {
            Curry._1(setContractor, (function (state) {
                    return {
                            tin: state.tin,
                            "type'": state["type'"],
                            country_code: state.country_code,
                            resident: state.resident,
                            name: state.name,
                            refnum: state.refnum,
                            email: state.email,
                            phone: state.phone,
                            contact: state.contact,
                            legal_address: state.legal_address,
                            real_address: state.real_address,
                            chief_tin: state.chief_tin,
                            chief_position: state.chief_position,
                            chief_family_name: state.chief_family_name,
                            chief_given_name: state.chief_given_name,
                            chief_patronymic_name: state.chief_patronymic_name,
                            chief_acting_on: state.chief_acting_on,
                            kbe: state.kbe,
                            bank_accounts: {
                              hd: bankAccount,
                              tl: /* [] */0
                            }
                          };
                  }));
          }
        }), [bankAccount]);
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
                                onSubmit: (function (param) {
                                    const __x = Buhta_cabinet__Document.ContractorService.create(tenant, contractor);
                                    $$Promise.get(__x, (function (result) {
                                            if (result.TAG !== /* Ok */0) {
                                              return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при отправке формы");
                                            }
                                            Buhta_cabinet__Route.navigateTo(contextRoute({
                                                      TAG: /* Manage */7,
                                                      _0: /* Contractors */{
                                                        _0: /* List */0
                                                      }
                                                    }));
                                            Curry._1(dispatchToasts, {
                                                  TAG: /* Add */0,
                                                  _0: {
                                                    id: Buhta_core__Toast.generateId(undefined),
                                                    text: "Контрагент успешно создан",
                                                    kind: "success",
                                                    onClick: (function (param) {
                                                        
                                                      })
                                                  }
                                                });
                                          }));
                                  }),
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Название",
                                        type_: "text",
                                        name: "name",
                                        size: "m",
                                        required: true,
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: value,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        value: contractor.name
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "ИИН/БИН",
                                        type_: "text",
                                        name: "tin",
                                        size: "m",
                                        required: true,
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: value,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.tin
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Dropdowns.OrgTypeSelect.make, {
                                        org_type: contractor["type'"],
                                        onOrgTypeSelect: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": value,
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          })
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Юридический адрес",
                                        type_: "text",
                                        name: "legal_address",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: value,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.legal_address
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Фактический адрес",
                                        type_: "text",
                                        name: "real_address",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: value,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.real_address
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                                              value: Formating.formatPhone(contractor.phone),
                                              onChange: (function (value) {
                                                  Curry._1(setContractor, (function (state) {
                                                          return {
                                                                  tin: state.tin,
                                                                  "type'": state["type'"],
                                                                  country_code: state.country_code,
                                                                  resident: state.resident,
                                                                  name: state.name,
                                                                  refnum: state.refnum,
                                                                  email: state.email,
                                                                  phone: value,
                                                                  contact: state.contact,
                                                                  legal_address: state.legal_address,
                                                                  real_address: state.real_address,
                                                                  chief_tin: state.chief_tin,
                                                                  chief_position: state.chief_position,
                                                                  chief_family_name: state.chief_family_name,
                                                                  chief_given_name: state.chief_given_name,
                                                                  chief_patronymic_name: state.chief_patronymic_name,
                                                                  chief_acting_on: state.chief_acting_on,
                                                                  kbe: state.kbe,
                                                                  bank_accounts: state.bank_accounts
                                                                };
                                                        }));
                                                })
                                            }),
                                        className: "mt-4"
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Почта",
                                        type_: "email",
                                        name: "email",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: value,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.email
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Контактное лицо",
                                        type_: "text",
                                        name: "contact",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: value,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.contact
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "КБе",
                                        type_: "text",
                                        name: "kbe",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: value,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.kbe
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                        className: "mt-6 text-default-gray",
                                        children: "Руководитель"
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Должность",
                                        type_: "text",
                                        name: "chief_position",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: value,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.chief_position
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Фамилия",
                                        type_: "text",
                                        name: "chief_family_name",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: value,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.chief_family_name
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Имя",
                                        type_: "text",
                                        name: "chief_given_name",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: value,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.chief_given_name
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "Отчество",
                                        type_: "text",
                                        name: "chief_patronymic_name",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: state.chief_tin,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: value,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.chief_patronymic_name
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                        label: "ИИН",
                                        type_: "text",
                                        name: "chief_tin",
                                        size: "m",
                                        onChange: (function (value) {
                                            Curry._1(setContractor, (function (state) {
                                                    return {
                                                            tin: state.tin,
                                                            "type'": state["type'"],
                                                            country_code: state.country_code,
                                                            resident: state.resident,
                                                            name: state.name,
                                                            refnum: state.refnum,
                                                            email: state.email,
                                                            phone: state.phone,
                                                            contact: state.contact,
                                                            legal_address: state.legal_address,
                                                            real_address: state.real_address,
                                                            chief_tin: value,
                                                            chief_position: state.chief_position,
                                                            chief_family_name: state.chief_family_name,
                                                            chief_given_name: state.chief_given_name,
                                                            chief_patronymic_name: state.chief_patronymic_name,
                                                            chief_acting_on: state.chief_acting_on,
                                                            kbe: state.kbe,
                                                            bank_accounts: state.bank_accounts
                                                          };
                                                  }));
                                          }),
                                        className: "mt-4",
                                        value: contractor.chief_tin
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                                      className: "text-default-gray",
                                                      children: "Реквизиты"
                                                    }),
                                                className: "flex justify-between items-center"
                                              }),
                                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                label: "IBAN",
                                                type_: "text",
                                                name: "iban",
                                                size: "m",
                                                onChange: (function (value) {
                                                    Curry._1(setBankAccount, (function (state) {
                                                            return {
                                                                    iban: value,
                                                                    bank_name: state.bank_name,
                                                                    bic: state.bic,
                                                                    default: state.default
                                                                  };
                                                          }));
                                                  }),
                                                className: "mt-4 mb-4",
                                                value: bankAccount.iban
                                              }),
                                          JsxRuntime.jsx(Buhta_cabinet__Dropdowns.BankSelect.make, {
                                                bank_id: 0,
                                                onBankSelect: (function (bank) {
                                                    Curry._1(setBankAccount, (function (state) {
                                                            return {
                                                                    iban: state.iban,
                                                                    bank_name: bank.name,
                                                                    bic: bank.bic,
                                                                    default: state.default
                                                                  };
                                                          }));
                                                  })
                                              })
                                        ],
                                        className: "mt-6 border border-gray-main rounded-md p-4"
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                        title: "Создать",
                                        className: "py-3 mt-6 w-full",
                                        type_: "submit"
                                      })
                                ]
                              }),
                          className: "w-140.5 shadow-card p-10 bg-white mt-10"
                        }),
                    className: "w-full flex flex-col items-center bg-gray-pale overflow-y-auto pb-10"
                  })
            });
}

const make = CreateContractorPage;

export {
  emptyContractor ,
  make ,
}
/* Buhta_cabinet__Btn Not a pure module */
